import { plainToClass } from '../../../../../node_modules/.pnpm/class-transformer@0.5.1/node_modules/class-transformer/esm5/index.js';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ChannelSubscriber = /*#__PURE__*/function () {
  function ChannelSubscriber(eventName, payloadModel, handler) {
    var _this = this;
    _classCallCheck(this, ChannelSubscriber);
    this.eventName = void 0;
    this.payloadModel = void 0;
    this.handler = void 0;
    this.eventName = eventName;
    this.payloadModel = payloadModel;
    this.handler = function (event) {
      var detail = ChannelSubscriber.extractDetail(event);
      var payload = plainToClass(_this.payloadModel, detail);
      handler(payload);
    };
    this.handler.bind(this);
    window.addEventListener(this.eventName, this.handler);
  }
  _createClass(ChannelSubscriber, [{
    key: "stop",
    value: function stop() {
      window.removeEventListener(this.eventName, this.handler);
    }
  }], [{
    key: "extractDetail",
    value: function extractDetail(event) {
      var detail = event.detail || {};
      var isObj = detail instanceof Object && !(detail instanceof Array);
      if (isObj) {
        return detail;
      }
      throw new Error('Event detail must be an object and can not be an array!');
    }
  }]);
  return ChannelSubscriber;
}();

export { ChannelSubscriber as default };
//# sourceMappingURL=ChannelSubscriber.js.map
